import { useMemo } from "react";
import { useTourDetailContext } from "../data/provider";

/**
 * A progress bar component that visually represents the progress of the current tour.
 * It does not interact with the tour directly.
 *
 * Future enhancement: Indicate the current stop with a different color.
 */
export function TourProgressBar() {
  const { tour, stops } = useTourDetailContext();

  const progress = useMemo(() => {
    if (!tour || stops.length === 0) {
      return 0;
    }

    const doneStops = stops.reduce(
      (count, stop) =>
        count + (stop.state === "done" || stop.state === "canceled" ? 1 : 0),
      0,
    );

    return (doneStops / stops.length) * 100;
  }, [stops, tour]);

  return (
    <div className="w-full h-1 bg-slate-100 relative">
      <div
        className="h-full bg-primary transition-all duration-500"
        style={{
          width: `${progress}%`,
        }}
      />
    </div>
  );
}
